<template>
    <div>
        <preloader :display="!isSettingsLoaded" />
        <div class="email-settings">
            <h1 class="email-settings__title typographies-heading-h1">
                <span>
                    {{ $l10n.__('Paramètres des emails') }}
                </span>
            </h1>
            <h3 v-if="isSetup" class="email-settings__subtitle typographies-heading-h3">
                <span>
                    {{ $l10n.__('Informations sur votre compte email') }}
                </span>
            </h3>
            <template v-if="isSettingsLoaded">
                <div v-if="!isSetup">
                    <EmailSettingAccountNotSynced
                        v-bind="account"
                        :isEmailsSentFromCorp="isEmailsSentFromCorp"
                    />
                </div>

                <div v-else>
                    <EmailSettingAccountSynced
                        v-if="isSyncMode"
                        v-bind="account"
                        :isEmailsSentFromCorp="isEmailsSentFromCorp"
                        @updateEmailStatus="getSettings"
                        @handleDisplayDialog="handleDisplayDisconnectPopup"
                    />

                    <EmailSettingPreferences :defaultValues="defaultValues" />
                </div>
            </template>
        </div>
        <disconnect-popup
            v-if="showDisconnectPopup"
            :visible="showDisconnectPopup"
            @close="handleCloseDialog"
            @handleDisconnect="logout"
        />
    </div>
</template>
<script>
import { getEmailSettings } from 'api/emailEngine/emailEngineService';
import EmailSettingAccountSynced from 'vcomponents/email/EmailSettingAccountSynced.vue';
import EmailSettingAccountNotSynced from 'vcomponents/email/EmailSettingAccountNotSynced.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import DisconnectPopup from 'vcomponents/email/DisconnectPopup.vue';
import EmailSettingPreferences from 'vcomponents/email/emailSettings/EmailSettingPreferences.vue';

export default {
    components: {
        EmailSettingAccountSynced,
        EmailSettingAccountNotSynced,
        Preloader,
        DisconnectPopup,
        EmailSettingPreferences,
    },
    data() {
        return {
            account: {},
            emailPrefs: {},
            isSettingsLoaded: false,
            emailSuccesfullyLinked: false,
            showDisconnectPopup: false,
            privateEmail: false,
            copyEmail: false,
            automaticallyAttachDocumentValue: true,
        };
    },
    computed: {
        isSetup() {
            return this.account.isSetup === 'Y';
        },
        isEmailsSentFromCorp() {
            return this.emailPrefs.emailsSentFromCorp === 'Y';
        },
        isSyncMode() {
            return this.account.isNylas === 'Y';
        },
        defaultValues() {
            return {
                copyEmail: this.copyEmail,
                privateEmail: this.privateEmail,
                automaticallyAttachDocumentValue: this.automaticallyAttachDocumentValue,
            };
        },
    },
    async mounted() {
        this.getSettings();
        const params = new URLSearchParams(window.location.search);
        const status = params.get('status');
        this.emailSuccesfullyLinked = status || false;
    },
    methods: {
        logout() {
            this.isSettingsLoaded = false;
            SellsyJS.WebServiceCaller.post('?_f=prefsNylas&action=logout', {}, {}, () => {
                this.getSettings();
                this.showDisconnectPopup = false;
            });
        },
        async getSettings() {
            this.isSettingsLoaded = false;
            getEmailSettings()
                .then((response) => {
                    const connection = response.data.connection;
                    this.account = this.getAccountData(connection);
                    this.emailPrefs = this.getEmailPrefsData(connection);
                    this.isSettingsLoaded = true;
                    this.privateEmail = response.data.private_mode;
                    this.copyEmail = response.data.add_sender_to_email;
                    this.automaticallyAttachDocumentValue =
                        response.data.automatically_attach_document;

                    if (!!this.emailSuccesfullyLinked && !!connection) {
                        this.$pushToast({
                            type: 'success',
                            close: true,
                            icon: true,
                            text: this.$t.__('settings.SettingsEmail.email_correctly_configured'),
                        });
                    }
                })
                .catch((error) => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: error,
                    });
                });
        },
        getAccountData(connection) {
            const account = {};
            if (connection === null) {
                account.isSetup = 'N';
                return account;
            }
            account.email = connection.email;
            account.modeName =
                connection.type === 'synchronization'
                    ? this.$l10n.__('Mode synchronisation')
                    : this.$l10n.__('Mode transfert');
            account.status = connection.status;
            account.isNylas = connection.type === 'synchronization' ? 'Y' : 'N';
            account.isSetup = 'Y';
            return account;
        },
        getEmailPrefsData(connection) {
            const emailPrefs = {};
            if (connection === null) {
                emailPrefs.emailsSentFromCorp = 'N';
                return emailPrefs;
            }
            emailPrefs.emailsSentFromCorp = connection.emails_sent_from_corp ? 'Y' : 'N';
            emailPrefs.onboarding_setup = connection.onboarding_setup ? 'Y' : 'N';
            return emailPrefs;
        },
        handleCloseDialog() {
            this.showDisconnectPopup = false;
        },
        handleDisplayDisconnectPopup() {
            this.showDisconnectPopup = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.email-settings {
    background-color: var(--colors-common-background-default);
    border: 1px solid var(--colors-common-border-default);
    border-radius: 4px;
    padding: var(--spacing-4);

    &__title {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin: 0 0 var(--spacing-3);
    }

    &__subtitle {
        margin: 0 0 var(--spacing-1);
    }
}
</style>
